import React, { forwardRef, Fragment } from "react";
import moment from "moment";
import CustomPagination from "../../../components/Common/CustomPagination";

const thClass = "px-2 py-1 text-left border-b border-slate-300 text-[11px] font-medium text-slate-800 bg-slate-100 capitalize tracking-wider align-middle whitespace-nowrap";
const tdClass = "border-b border-slate-200 px-2 h-[24px] align-middle text-[11px] font-medium text-slate-900 whitespace-nowrap";
const buttonClass = "h-[28px] px-3.5 text-[11px] font-medium rounded-none shadow-2xs transition-colors capitalize tracking-wider cursor-pointer";

const columns = [
    { label: "Select", className: "w-[48px] text-center" },
    { label: "No.", className: "w-[44px]" },
    { label: "Vessel Name" },
    { label: "DWT", className: "text-right" },
    { label: "Port" },
    { label: "Date Opening" },
    { label: "Hire Per Day", className: "text-right" },
    { label: "Hire GBB", className: "text-right" },
    { label: "Remark" },
    { label: "Created On" },
    { label: "Created By" },
];

const VesselList = forwardRef((props, ref) => {
    const {
        fleets,
        onChangeVesselPagination,
        vesselFilters,
        onCloseSaveCargoCargoVessel,
        onClickVessel,
        selectedVessel,
        onCreateVesselClick,
        hasFetchedFleets = false,
    } = props;

    return (
        <Fragment>
            <div className="w-full flex flex-col gap-2">
                <div className="overflow-x-auto w-full">
                    <table className="w-full text-left border-collapse border border-slate-300">
                        <thead>
                            <tr>
                                {columns.map((col) => (
                                    <th key={col.label} className={`${thClass} ${col.className || ""}`}>
                                        {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(fleets) && fleets.length ? (
                                fleets.map((item, index) => {
                                    const vesselName = item?.vessel ? JSON.parse(item?.vessel)?.vesselName : item?.vesselName;
                                    const isSelected = selectedVessel?._id === item?._id;
                                    return (
                                        <tr
                                            key={index}
                                            onClick={() => onClickVessel({ target: { checked: !isSelected } }, item)}
                                            className={`cursor-pointer ${isSelected ? "bg-slate-100" : index % 2 ? "bg-slate-50 hover:bg-slate-100" : "bg-white hover:bg-slate-100"}`}
                                        >
                                            <td className={`${tdClass} text-center`}>
                                                <input
                                                    type="checkbox"
                                                    checked={isSelected}
                                                    onClick={(e) => e.stopPropagation()}
                                                    onChange={(e) => onClickVessel(e, item)}
                                                    aria-label="Select vessel"
                                                    className="h-3.5 w-3.5 border-slate-300 rounded cursor-pointer align-middle m-0"
                                                />
                                            </td>
                                            <td className={tdClass}>{index + 1}</td>
                                            <td className={tdClass}>{vesselName}</td>
                                            <td className={`${tdClass} text-right tabular-nums`}>{item.dwt || 0}</td>
                                            <td className={tdClass}>{item.port || ""}</td>
                                            <td className={tdClass}>{moment(item.dateOpen).format("DD/MMM/yyyy")}</td>
                                            <td className={`${tdClass} text-right tabular-nums`}>{item.hirePerDay || ""}</td>
                                            <td className={`${tdClass} text-right tabular-nums`}>{item.hireGbb || 0}</td>
                                            <td className={`${tdClass} max-w-[200px] truncate`} title={item.remark || ""}>{item.remark || ""}</td>
                                            <td className={tdClass}>
                                                {item.createdDate ? moment(item.createdDate).format("DD/MMM/yyyy") : ""}
                                            </td>
                                            <td className={tdClass}>
                                                {item?.createdUser ? `${item.createdUser?.firstName} ${item.createdUser?.lastName}` : ""}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : hasFetchedFleets ? (
                                <tr>
                                    <td colSpan={columns.length} className={`${tdClass} text-center bg-white`}>
                                        No Fleet Found.
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>

                <div className="flex items-center justify-between w-full">
                    <CustomPagination
                        onChangePagination={onChangeVesselPagination}
                        filters={vesselFilters}
                        totalPage={vesselFilters?.totalPages}
                    />
                    <div className="flex items-center gap-2.5">
                        <button
                            onClick={onCloseSaveCargoCargoVessel}
                            className={`${buttonClass} text-slate-900 bg-white hover:bg-slate-100 border border-slate-300`}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onCreateVesselClick}
                            className={`${buttonClass} text-white bg-[#313C4C] hover:bg-[#1e2632] border border-[#313C4C]`}
                        >
                            Create
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
});

export default VesselList;
